import React from 'react';
import './Container.scss';
import { classNames } from 'react-extras';

type SizeEnum = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';

const Container = ({
    children,
    size,
    className,
    anchorId,
    ...props
}: {
    children: React.ReactNode;
    size?: SizeEnum;
    className?: string;
    anchorId?: string | null;
}) => {
    const containerClasses = classNames('Container', {
        [`Container--${size}`]: size,
    });

    return (
        <div className={`${containerClasses} ${className || ''}`} id={`${anchorId || ''}`} {...props}>
            {children}
        </div>
    );
};

export { Container };
